/**
 * DevExtreme (esm/core/templates/child_default_template.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    TemplateBase
} from "./template_base";
export class ChildDefaultTemplate extends TemplateBase {
    constructor(name) {
        super();
        this.name = name
    }
}
